import { useState } from 'react';

const testimonials = [
  {
    title: "The Wildfire Savior",
    quote: "Amazing what this clears from the air. The end of the fire season here in BC, it was a noticeable help. Would recommend this highly!",
    author: "Gretchen H.",
    source: "Airdog X8 User",
    bgColor: "bg-red-50",
    borderColor: "border-red-100",
    starColor: "text-red-400",
  },
  {
    title: "The Smoke & Pet Combo",
    quote: "Cleans the air — can't tell I have dogs or smoke! When people visit, they think I quit smoking. They're always surprised I have dogs because there's no smell.",
    author: "ejohns74",
    source: "Verified Buyer",
    bgColor: "bg-amber-50",
    borderColor: "border-amber-100",
    starColor: "text-amber-400",
  },
  {
    title: "The Allergy Relief",
    quote: "The X8 has been fantastic to minimize dust and pollen in our 3000+ sq ft home. We have severe allergies and live in a high wind area — it's minimized our medication use. We were so impressed we bought an X5 for the master suite.",
    author: "Verified Customer",
    source: "Walmart.com",
    bgColor: "bg-emerald-50",
    borderColor: "border-emerald-100",
    starColor: "text-emerald-400",
  },
  {
    title: "The Sleep & Breathing Specialist",
    quote: "After two weeks with the X3 in our bedroom, we were sleeping better and breathing easier. Cooking smells that usually lingered upstairs simply didn't anymore.",
    author: "Mordechai L.",
    source: "GeekDad Reviewer",
    bgColor: "bg-sky-50",
    borderColor: "border-sky-100",
    starColor: "text-sky-400",
  },
  {
    title: "The Life-Saver",
    quote: "I had a debilitating cough for 11 months with no answer from specialists. Within days of running the X8, my cough was 95% gone. It's not the cheapest, but it's the best investment we've made.",
    author: "Teamgunner",
    source: "Verified Walmart / Airdog Customer",
    bgColor: "bg-violet-50",
    borderColor: "border-violet-100",
    starColor: "text-violet-400",
  },
  {
    title: "The Fire Season & Multi-Dog Solution",
    quote: "Three X5s and one X8 — flawless for years. You notice the difference immediately during fire season or with dogs in the room. I love that I just wash the plates in hot water once a month.",
    author: "S. Beard",
    source: "Verified Airdog Customer",
    bgColor: "bg-orange-50",
    borderColor: "border-orange-100",
    starColor: "text-orange-400",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="py-6 md:py-8 pb-10 md:pb-12 bg-[#FAF8F5] scroll-mt-20 relative z-0">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-5 md:mb-6">
          <span className="inline-block text-[11px] font-bold tracking-[0.2em] uppercase text-brand mb-1.5">
            Real Experiences
          </span>
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-1.5">
            What Customers Are Saying
          </h2>
          <div className="w-10 h-0.5 bg-brand rounded-full mx-auto" />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 max-w-6xl mx-auto">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className={`relative ${t.bgColor} rounded-xl border ${t.borderColor} hover:shadow-md transition-shadow duration-300 flex flex-col overflow-hidden`}
            >
              <div className="p-3.5 flex flex-col flex-1">
                <div className="flex items-center gap-1 mb-1.5">
                  <div className="flex">
                    {[...Array(5)].map((_, j) => (
                      <i key={j} className={`ri-star-fill ${t.starColor} text-[11px]`} />
                    ))}
                  </div>
                  <span className="text-[10px] font-bold text-gray-500">5.0</span>
                </div>

                <p className="text-[10px] font-extrabold tracking-wider text-gray-700 uppercase mb-1">
                  {t.title}
                </p>

                <blockquote className="text-[11px] text-gray-800 font-semibold leading-relaxed mb-2 flex-1">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>

                <div className="pt-1.5 border-t border-gray-200/60">
                  <p className="text-[11px] font-bold text-gray-900">— {t.author}</p>
                  <p className="text-[10px] text-gray-600 font-semibold mt-0.5">{t.source}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}